module.exports = __webpack_public_path__ + "img/MNEX25-default-front.16a507a6.jpg";